import styled from 'styled-components';
import uploadBg from '~/assets/img/upload-bg.png';

export const Container = styled.div`
  width: 95%;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;
export const Left = styled.div`
  width: 40%;
`;
export const Right = styled.div`
  width: 100%;
`;

export const BoxUpload = styled.div`
  width: 365px;
  height: 249px;
  margin: 0 auto;
  /* border-radius: 8px;
  border: dashed 2px #5a9fb0;
  background-color: #fff; */
  display: flex;
  justify-content: center;
  align-items: center;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    input {
      background-image: url(${uploadBg});
      background-repeat: no-repeat;
      background-position: center 40px;
      display: block;
      width: 365px;
      height: 249px;
      border-radius: 8px;
      border: dashed 2px #5a9fb0;
      background-color: #fff;
      text-indent: -9999px;
      cursor: pointer;
      position: absolute;
      color: #fff;
    }
    span.fileUploadText {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.13;
      letter-spacing: 0.01px;
      text-align: center;
      color: #6c6c6c;
      display: block;
      position: relative;
      top: 60px;
    }
  }
`;

export const BoxSendButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  button {
    width: 122px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
`;

export const BoxInstructions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 3;
    letter-spacing: normal;
    text-align: center;
    color: #6c6c6c;
  }
  p {
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #235f6e;
    text-decoration: underline;
  }
  a {
    color: #235f6e;
  }
`;

export const BoxSendtoPanel = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const SendButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  button {
    margin-top: 10px;
    width: 150px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    /* margin-left: 80px; */
  }
  span {
    /* margin-left: 80px; */
    font-size: 12px;
    font-style: italic;
    color: #6d6d6d;
    display: block;
    margin-top: 10px;
    text-align: center;
  }
`;

export const ErrorButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  button {
    margin-top: 10px;
    width: 150px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #cc0000;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
`;

export const ProgressUpload = styled.div`
  width: 480px;
  margin: 0 auto 30px auto;
  padding-bottom: 25px;
  border-bottom: solid 1px #ddd;
  span.analysisTitle {
    margin-top: 0;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #282828;

    display: block;
  }
  p {
    font-size: 13px;
    font-style: italic;
    color: #6d6d6d;
    margin: 10px 0 20px 0;
  }
  span.analysisTitle.error {
    color: #cc0000;
    margin-bottom: 20px;
    display: block;
  }
  div.bodyProgress {
    display: flex;
    flex-direction: row;
  }
`;

export const IconCSV = styled.div`
  width: 60px;
  position: relative;
  img {
    :last-child {
      position: absolute;
      bottom: 12px;
      right: -3px;
    }
  }
`;

export const BoxProgress = styled.div`
  width: 100%;
  margin-left: 10px;
  p {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: left;
    color: ${({ error }) => (error ? '#cc0000' : '#74a50a')};
    margin-bottom: 5px;
  }
  div.titleProgress {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    img {
      margin-bottom: 5px;
    }
  }
`;

export const PercentageSize = styled.div`
  margin-top: 7px;
  p {
    font-size: 15px;
    font-weight: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${({ error }) => (error ? '#cc0000' : '#74a50a')};
  }
`;

export const ProgressLoading = styled.div`
  width: 100%;
  height: 13px;
  border-radius: 100px;
  background-color: ${({ error }) => (error ? '#cc0000' : '#74a50a')};
`;

export const ButtonTop = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  button {
    width: 162px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #00698b;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
`;
